import './AdminCharts.css';

export function VerticalBarChart({ title, subtitle, data = [] }) {
  const maxValue = Math.max(...data.map((item) => item.value || 0), 1);

  return (
    <section className="admin-graph-card">
      <div className="admin-graph-header">
        <h3>{title}</h3>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>

      {data.length === 0 ? (
        <div className="admin-graph-empty">Aucune donnée disponible</div>
      ) : (
        <div className="admin-bar-chart">
          {data.map((item) => (
            <div key={item.label} className="admin-bar-item">
              <span className="admin-bar-value">{item.value}</span>
              <div className="admin-bar-track">
                <div
                  className="admin-bar-fill"
                  style={{
                    height: `${Math.max((item.value / maxValue) * 100, 6)}%`,
                    background: item.color,
                  }}
                />
              </div>
              <span className="admin-bar-label">{item.label}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export function HorizontalBarChart({ title, subtitle, data = [] }) {
  const maxValue = Math.max(...data.map((item) => item.value || 0), 1);

  return (
    <section className="admin-graph-card">
      <div className="admin-graph-header">
        <h3>{title}</h3>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>

      {data.length === 0 ? (
        <div className="admin-graph-empty">Aucune donnée disponible</div>
      ) : (
        <div className="admin-horizontal-chart">
          {data.map((item) => (
            <div key={item.label} className="admin-horizontal-item">
              <div className="admin-horizontal-meta">
                <span>{item.label}</span>
                <strong>{item.value}</strong>
              </div>
              <div className="admin-horizontal-track">
                <div
                  className="admin-horizontal-fill"
                  style={{
                    width: `${(item.value / maxValue) * 100}%`,
                    background: item.color,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export function DonutChart({ title, subtitle, data = [] }) {
  const total = data.reduce((sum, item) => sum + (item.value || 0), 0);
  const radius = 42;
  const circumference = 2 * Math.PI * radius;
  let offset = 0;

  return (
    <section className="admin-graph-card">
      <div className="admin-graph-header">
        <h3>{title}</h3>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>

      {total === 0 ? (
        <div className="admin-graph-empty">Aucune donnée disponible</div>
      ) : (
        <div className="admin-donut-layout">
          <div className="admin-donut-wrap">
            <svg viewBox="0 0 120 120" className="admin-donut-svg" aria-hidden="true">
              <circle cx="60" cy="60" r={radius} className="admin-donut-base" />
              {data.map((item) => {
                const slice = ((item.value || 0) / total) * circumference;
                const currentOffset = offset;
                offset += slice;

                return (
                  <circle
                    key={item.label}
                    cx="60"
                    cy="60"
                    r={radius}
                    className="admin-donut-segment"
                    style={{
                      stroke: item.color,
                      strokeDasharray: `${slice} ${circumference - slice}`,
                      strokeDashoffset: -currentOffset,
                    }}
                  />
                );
              })}
            </svg>
            <div className="admin-donut-center">
              <strong>{total}</strong>
              <span>plans</span>
            </div>
          </div>

          <div className="admin-donut-legend">
            {data.map((item) => (
              <div key={item.label} className="admin-donut-legend-item">
                <span className="admin-donut-dot" style={{ background: item.color }} />
                <span className="admin-donut-legend-label">{item.label}</span>
                <strong className="admin-donut-legend-value">{item.value}</strong>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}